var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{staticClass:"about",attrs:{"modal-aria-label":_vm.modalAriaLabel}},[_c(_vm.cipherAbouComponent,{tag:"component",attrs:{"cipher":_vm.cipher,"utils":_vm.utils}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }